"use strict";

angular.module("internal.exams").controller("InternalExamForms", [
    "$scope",
    "$rootScope",
    "Resource",
    "Cache",
    "EXForms",
    "$q",
    function($scope, $rootScope, Resource, Cache, EXForms, $q) {
        $scope.loading = true;
        $scope.bulkActionItems = [];
        $scope.packetSearch = [{ name: "No Packet", id: "No Packet" }];
        $scope.listParams = {
            currentPage: 0,
            numPerPage: 10
        };
        $scope.ShowActive = true;
        $scope.active = Resource.activeOptions();
        $scope.yesno = Resource.yesNoOptions();
        $scope.selectedCategory = "";
        $scope.bulkActionRunning = false;

        $scope.setStatus = function(bulkApply, status) {
            var promises = [];
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;

            if (status != null && $scope.bulkActionItems.length > 0) {
                promises.push(
                    EXForms.updateStatus($scope.bulkActionItems, status).then(
                        function() {}
                    )
                );
            }
            $q.all(promises).then(function() {
                $scope.bulkActionItems = [];
                $scope.packetSearch = [{ name: "No Packet", id: "No Packet" }];
                $scope.getExamForms();
                $scope.bulkActionRunning = false;
            }).catch(function (response) {
                // handle error
            });
        };

        $scope.getExamForms = function() {
            $scope.loading = true;
            EXForms.get().then(function (ExamForm) {
                $scope.forms = ExamForm.records;
                var nameList = [];
                $scope.forms.forEach(function (f) {
                    if (!f.minimumSkillPoints) f.minimumSkillPoints = 0;
                    if (!f.maximumCriticalSkillFailures) f.maximumCriticalSkillFailures = 0;
                    f.title = f.comments;
                    if (f.active == null) f.active = false;
                    EXForms.getPacketListById(f.id).then(function (packetList) {
                        f.packets = packetList.records;
                        f.packetList = "";
                        f.packets.forEach(function (p) {
                            if (f.packetList.length > 0)
                                f.packetList += ", " + p.name;
                            else f.packetList += p.name;
                            if (nameList.indexOf(p.name) < 0) {
                                $scope.packetSearch.push({
                                    name: p.name,
                                    id: p.name
                                });
                                nameList.push(p.name);
                            }
                        });

                    }).then(function () {
                        if (f.packetList.length == 0) f.packetList = "No Packet";
                    });
                });
                $scope.loading = false;
            });
        };

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.form.details",
                    params: [
                        {
                            name: "id",
                            field: "id"
                        }
                    ]
                }
            },
            {
                label: "Packets(s)",
                field: "packetList"
            },
            {
                label: "Active",
                field: "activeStatus",
                type: "yesno"
            },
            {
                label: "Required Points",
                field: "minimumSkillPoints"
            },
            {
                label: "Max Missed Critical Skills",
                field: "maximumCriticalSkillFailures"
            },
            {
                label: "Last Modified",
                field: "modifiedOnUtc",
                type: "date"
            }
        ];

        Cache.getState("list").then(function(state) {
            if (state != null) {
                $scope.sortBy = state.sortBy;
                $scope.reverse = state.reverse;
                $scope.search = state.search;
                $scope.active = state.active;
                $scope.packets = state.packets;
            } else {
                $scope.listParams.currentPage = 0;
                $scope.listParams.numPerPage = 10;
            }
        });

        $scope.cacheList = function() {
            var state = {
                sortBy: $scope.sortBy,
                reverse: $scope.reverse,
                search: $scope.search,
                currentPage: $scope.listParams.currentPage,
                numPerPage: $scope.listParams.numPerPage,
                status: $scope.status
            };

            Cache.setState("list", state);
        };

        $scope.$watch("search + status", function(old, newie) {
            if (old != newie) {
                $scope.listParams.currentPage = 0;
                $scope.cacheList();
            }
        });

        $scope.$watch(
            "listParams.currentPage + listParams.numPerPage + sortBy + reverse",
            function(old, newie) {
                if (old != newie) {
                    $scope.cacheList();
                }
            }
        );

        $scope.clear = function() {
            $scope.search = "";
            $scope.listParams.currentPage = 0;
            $scope.status = "";
            $scope.inspector = "";
            $scope.cacheList();
        };

        $scope.checkAllexams = function(event, checkAll, visits) {
            event.stopImmediatePropagation();
            visits.forEach(function(visit) {
                visit.bulkActionItems = [];
                visit.exams.forEach(function(inspection) {
                    inspection.inBulkApply = checkAll;
                    if (checkAll) {
                        visit.bulkActionItems.push(inspection.id);
                    }
                });
            });
        };

        $scope.filters = [
            {
                name: "Active",
                field: "activeStatus",
                options: [
                    { name: "Active", id: true },
                    { name: "Inactive", id: false }
                ]
            },
            {
                name: "Packet",
                field: "packetList",
                options: $scope.packetSearch
            }
        ];

        $scope.getExamForms();
    }
]);
